import { StateNode } from '@ansys-internal/awf-angular/store';
import { DriveCyclePlotAxis } from 'src/app/shared/types';

export class DriveCycleAxisState implements StateNode<DriveCyclePlotAxis[]> {
  key: string = 'driveCycleAxis';
  mutable: boolean = true;
  observeInitial: boolean = true;
  defaultValue: () => DriveCyclePlotAxis[] = () => [];
}
